import React, { useState, useEffect } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi2';
import { Table, pagesColumns } from '../../../commons/Table';
import { Modal, SEO } from '../../../commons';
import { DAV_APIS } from '../../../../adapters';
import { DAV_MAIN_DOMAIN } from '../../../../constants';
import { Card } from '../../../ui/Card';

const Pages = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pageData, setPageData] = useState<any[]>([]);
  const [record, setRecord] = useState<any>({}); // for edit and view
  const [refresh, setRefresh] = useState(null);

  const handleEdit = (e: any, data: any) => {
    e.stopPropagation();
    setShowModal(true);
    setRecord(data);
  };

  const handleView = (e: any, data: any) => {
    e.stopPropagation();
    if (data.slug === 'home') {
      window.open(`${DAV_MAIN_DOMAIN}`, '_blank');
      return;
    }
    window.open(`${DAV_MAIN_DOMAIN}/${data.slug}`, '_blank');
  };

  useEffect(() => {
    const fetchStaticPages = async () => {
      setLoading(true);
      try {
        const res = await DAV_APIS.getSearchEngineDataByPageType('page');
        if (res.status === 200) {
          setPageData(res.data.seos);
        }
      } catch (error) {
        console.error('Failed to fetch static pages:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStaticPages();
  }, [refresh]);

  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Static Pages SEO
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1 text-sm md:text-base'>
            Optimize your core website pages for search engines.
          </p>
        </div>

      </div>

      {/* Main Content Card */}
      <Card variant='glass' className='overflow-hidden border-none shadow-xl shadow-gray-200/50 dark:shadow-none'>
        {/* @ts-ignore */}
        <Table
          columns={pagesColumns}
          data={pageData}
          loading={loading}
          onEditHandler={handleEdit}
          onViewHandler={handleView}
          viewExternal
          recordName='Pages'
          placeholder='Search by page title or slug...'
        />
      </Card>
      
      {/* Info Notice */}
      <div className='flex items-center gap-2 p-4 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-gray-100 dark:border-gray-700/50 text-xs text-gray-500 dark:text-gray-400'>
        <HiOutlineInformationCircle className='w-4 h-4 text-primary-500' />
        Updating SEO metadata might take 24-48 hours to reflect in search engine results.
      </div>

      <Modal
        size='lg'
        open={showModal}
        onClose={() => setShowModal(false)}
        hideCancelButton
        hideSuccessButton
      >
        <SEO
          isModal
          isEdit
          pageType='page'
          setRefresh={setRefresh}
          setShowModal={setShowModal}
          initialData={{
            title: record?.title,
            description: record?.description,
            image: record?.SEOImage,
            slug: record?.slug,
          }}
        />
      </Modal>
    </div>
  );
};

export default Pages;
